<template>
	<div style="text-align: left;">
		<van-tabs v-model="orderStatus" @click="queryOrder" >
		  <van-tab title="全部" name="全部">
			  <van-empty description="空空如也" v-if="orderLists.length==0">
			    <van-button round type="danger" class="bottom-button" to="/">去下单</van-button>
			  </van-empty>
			  <!-- 订单列表 -->
			  <van-list
			    v-model="loading"
			    :finished="finished"
			    :finished-text="finishedText"
			    @load="onLoad"
			    :immediate-check="false"
			  >
			  <div v-for="(item,index) in orderLists " :key="item.id" >
				  <!-- 是否具有子订单 -->
				  <template v-if="!item.order_list">
					  <div @click="goOrderInfo(item.id)">
						  <van-row style="padding: 10px 20px;" class="order-list-title">
						  		<van-col span="20" style="text-align:left;">
						  			<span>订单编号:</span>
						  			<span>{{item.out_trade_no}}</span>
						  		</van-col>
						  		<van-col span="4" style="text-align:right;">
						  			<span style="color: orangered;">{{item.order_state}}</span>
						  		</van-col>
						  	  </van-row>
						  	  <van-row style="display: flex;padding: 0 20px;align-items: center;">
						  	    <van-col span="6" v-for="(img,index) in item.img_list.slice(0,3)" :key="index">
						  			<van-image
						  			  width="80"
						  			  height="80"
						  			  :src="img"
						  			/>
						  		</van-col>
						  		<van-col span="6" style="flex: 1;  color: #444;font-size: 12px; display: flex;justify-content: flex-end;">
									<div style="display: flex;align-items: center;text-align: right;">
										<div >
											<div>￥{{item.total_fee}}</div>
											<div>共{{item.goods_sum}}件</div>
										</div>
										<van-icon name="arrow" style="margin-left: 4px;" />
									</div>																							
						  		</van-col>
						  	  </van-row>			  	
						  <van-row style="display: flex;padding: 0 20px;" v-if="item.order_state=='待支付'">
						  	<van-col span="16" style=" flex:1;text-align: left; color: red; font-size: 14px;" >
						  		<span>等待付款 </span><van-count-down :time="(item.limit_time-item.current_time)*1000"  style="display: inline;"/>
						  	</van-col>
						  	<van-col span="8" style="flex:1;text-align: right; ">
								<van-button type="danger"  plain  round size="mini" @click.stop="rePay(item.id)">立即支付</van-button>
						  	</van-col>
						   </van-row>
					  </div>
				  </template>
				  <!-- 如果有子订单 -->
				  <template v-else>
					  <div @click="goOrderInfo(itemList.id)" v-for="(itemList,index) in item.order_list" :key="itemList.id">
					    <van-row style="padding: 10px 20px;" class="order-list-title">
					  	<van-col span="20" style="text-align:left;">
					  		<span>订单编号:</span>
					  		<span>{{itemList.out_trade_no}}</span>
					  	</van-col>
					  	<van-col span="4" style="text-align: right;">
					  		<span style="color: orangered;">{{itemList.order_state}}</span>
					  	</van-col>
					    </van-row>
						<van-row style="display: flex;padding: 0 20px;align-items: center;">
						    <van-col span="6" v-for="(img,index) in itemList.img_list.slice(0,3)" :key="index">
								<van-image
								  width="80"
								  height="80"
								  :src="img"
								/>
							</van-col>
							<van-col span="6" style="flex: 1;  color: #444;font-size: 12px; display: flex;justify-content: flex-end;">
								<div style="display: flex;align-items: center;text-align: right;">
									<div >
										<div>￥{{itemList.total_fee}}</div>
										<div>共{{itemList.goods_sum}}件</div>
									</div>
									<van-icon name="arrow" style="margin-left: 4px;" />
								</div>																							
							</van-col>							
						  </van-row>
							<div style="text-align: right;padding-right: 20px;" v-if="itemList.order_state =='已完成' || itemList.order_state=='待配货' || itemList.order_state=='部分退款'">
								<van-button color='#666'  plain  round size="mini"  @click.stop='goReturnOrder(itemList.id)'>退款/售后</van-button>
							</div>											  
					  </div>
				  </template>
			    <van-divider />
			  </div>			
			</van-list>
		  </van-tab>
		  <van-tab title="待支付" name="待支付">
			  <van-empty description="您没有待支付的订单" v-if="orderLists.length==0">
			  </van-empty>
			  <!-- 订单列表 -->			  
			    <van-list
			      v-model="loading"
			      :finished="finished"
			      :finished-text="finishedText"
			      @load="onLoad"
				  :immediate-check="false"
			    >
				<!-- 新版样式 -->
				<div @click="goOrderInfo(item.id)" v-for="(item,index) in orderLists" :key="index">
					  <van-row style="padding: 10px 20px;" class="order-list-title">
						<van-col span="20" style="text-align:left;">
							<span>订单编号:</span>
							<span>{{item.out_trade_no}}</span>
						</van-col>
						<van-col span="4" style="text-align:right;">
							<span style="color: orangered;">{{item.order_state}}</span>
						</van-col>
					  </van-row>
				  <!-- 商品卡片 -->
					  <!-- <van-row style="display: flex;padding: 0 20px;align-items: center;">
					    <van-col span="6" v-for="(img,index) in item.img_list.slice(0,3)" :key="index">
							<van-image
							  width="80"
							  height="80"
							  :src="img"
							/>
						</van-col>
						<van-col span="6" style="flex: 1; text-align: right; color: #444;font-size: 12px;">
							共{{item.goods_sum}}件<van-icon name="arrow" />
						</van-col>
					  </van-row>
					<van-row style="padding:5px 20px 10px 0;font-size: 14px;">
						<van-col span="24" style="flex:1;text-align: right;">
							共{{item.goods_sum}}件商品,合计:￥{{item.total_fee}}
						</van-col>
					</van-row> -->
					<van-row style="display: flex;padding: 0 20px;align-items: center;">
					    <van-col span="6" v-for="(img,index) in item.img_list.slice(0,3)" :key="index">
							<van-image
							  width="80"
							  height="80"
							  :src="img"
							/>
						</van-col>
						<van-col span="6" style="flex: 1;  color: #444;font-size: 12px; display: flex;justify-content: flex-end;">
							<div style="display: flex;align-items: center;text-align: right;">
								<div>
									<div>￥{{item.total_fee}}</div>
									<div>共{{item.goods_sum}}件</div>
								</div>
								<van-icon name="arrow" style="margin-left: 4px;" />
							</div>																							
						</van-col>								
					  </van-row>										
				<van-row v-if="item.order_state=='待支付'"  style="display: flex;padding: 0 20px;">
					<van-col span="16" style=" flex:1;text-align: left; color: red; font-size: 14px;" >
						<span>等待付款 </span><van-count-down :time="(item.limit_time-item.current_time)*1000"  style="display: inline;"/>
					</van-col>
					<van-col span="8" style="flex:1;text-align: right; ">
						<van-button  type="danger"  plain  round size="mini" @click.stop="rePay(item.id)">立即支付</van-button>
					</van-col>
				 </van-row>
				  <van-divider />
				</div>
			</van-list>
		  </van-tab>
		  <van-tab title="待提货" name="待提货">
			  <van-empty description="您没有待提货的订单" v-if="orderLists.length==0">
			  </van-empty>
			  <!-- 订单列表 -->
			  <van-list
			    v-model="loading"
			    :finished="finished"
			    :finished-text="finishedText"
			    @load="onLoad"
			    :immediate-check="false"
			  >
			  <div v-for="(orderList,index) in orderLists" :key="index">
				  <div @click="goOrderInfo(item.id)" v-for="(item,index) in orderList.order_list" :key="index">
					  <van-row style="padding: 10px 20px;" class="order-list-title">
						<van-col span="20" style="text-align:left;">
							<span>订单编号:</span>
							<span>{{item.out_trade_no}}</span>
						</van-col>
						<van-col span="4" style="text-align: right;">
							<span style="color: orangered;">{{item.order_state}}</span>
						</van-col>
					  </van-row>
					  <!-- 商品卡片 -->
					  <!-- <van-card
						:num="goods.quantity"
						:price="goods.amount.toFixed(2)"
						:desc="goods.size ? goods.size : ''"
						:title="goods.name"
						:thumb="goods.thumb_image"
						v-for="(goods,index) in item.order_detail" :key="index"
					  />
					  <van-row style="display: flex;padding: 10px 20px;justify-content: flex-end;">							
						<van-col>
							共{{item.goods_sum}}件商品,合计:￥{{item.total_fee}}
						</van-col>
					  </van-row> -->
					  
					  <van-row style="display: flex;padding: 0 20px;align-items: center;">
					      <van-col span="6" v-for="(img,index) in item.img_list.slice(0,3)" :key="index">
					  		<van-image
					  		  width="80"
					  		  height="80"
					  		  :src="img"
					  		/>
					  	</van-col>
					  	<van-col span="6" style="flex: 1;  color: #444;font-size: 12px; display: flex;justify-content: flex-end;">
					  		<div style="display: flex;align-items: center;text-align: right;">
					  			<div >
					  				<div>￥{{item.total_fee}}</div>
					  				<div>共{{item.goods_sum}}件</div>
					  			</div>
					  			<van-icon name="arrow" style="margin-left: 4px;" />
					  		</div>																							
					  	</van-col>	
					    </van-row>
					  <div style="text-align: right;padding-right: 20px;">
					  	<van-button color='#666'  plain  round size="mini"  @click.stop='goReturnOrder(item.id)'>退款/售后</van-button>
					  </div>
					  
					  <van-divider />
				  </div>
			  </div>

			</van-list>
		  </van-tab>
		  <van-tab title="已完成" name="已完成">
				<van-empty description="您没有已完成的订单" v-if="orderLists.length==0">
				</van-empty>
			  <!-- 订单列表 -->
			  <van-list
			    v-model="loading"
			    :finished="finished"
			    :finished-text="finishedText"
			    @load="onLoad"
			    :immediate-check="false"
			  >
				<div v-for="(orderList,index) in orderLists" :key="index">
				  <div @click="goOrderInfo(item.id)" v-for="(item,index) in orderList.order_list" :key="index">
					  <van-row style="padding: 10px 20px;" class="order-list-title">
						<van-col span="20" style="text-align:left;">
							<span>订单编号:</span>
							<span>{{item.out_trade_no}}</span>
						</van-col>
						<van-col span="4" style="text-align: right;">
							<span style="color: orangered;">{{item.order_state}}</span>
						</van-col>
					  </van-row>
					  <!-- 商品卡片 -->
					  
					  <van-row style="display: flex;padding: 0 20px;align-items: center;">
					      <van-col span="6" v-for="(img,index) in item.img_list.slice(0,3)" :key="index">
					  		<van-image
					  		  width="80"
					  		  height="80"
					  		  :src="img"
					  		/>
					  	</van-col>
					  	<van-col span="6" style="flex: 1;  color: #444;font-size: 12px; display: flex;justify-content: flex-end;">
					  		<div style="display: flex;align-items: center;text-align: right;">
					  			<div>
					  				<div>￥{{item.total_fee}}</div>
					  				<div>共{{item.goods_sum}}件</div>
					  			</div>
					  			<van-icon name="arrow" style="margin-left: 4px;" />
					  		</div>																							
					  	</van-col>	
					    </van-row>
						<div style="text-align: right;padding-right: 20px;">
							<van-button color='#666'  plain  round size="mini"  @click.stop='goReturnOrder(item.id)'>退款/售后</van-button>
						</div>						
					  <van-divider />
				  </div>
			  </div>
			 </van-list>  
		  </van-tab>
		</van-tabs>
		<van-tabbar route placeholder safe-area-inset-bottom active-color="#E74C3C">
		   <van-tabbar-item replace to='/activityList' icon="home-o">首页</van-tabbar-item>
		   <van-tabbar-item replace to="/userCenter" icon="user-o">我的</van-tabbar-item>
		 </van-tabbar>
	</div>
</template>

<script>
	import { Empty } from 'vant';
	export default{
		name:"orderList",
		data(){
			return{
				orderStatus:'全部',
				titles:['全部','待支付','待提货','已完成'],
				orderLists:[],	
				total:0,
				//order_status:'全部',
				page:1,
				last_page:1,
			    loading: false,
			    finished: false,
			    refreshing: false,
				requestFlag:true,
				finishedText:''
				
			}
		},
		methods:{
			
			queryOrder(name){			
				this.page=1
				this.orderLists=[]
				this.finishedText=''
				//this.finished=false
				this.getOrderList()
			},
			 goOrderInfo(id){
				 // this.$router.push('/orderInfo')
				 this.$router.push({
					 path:'/orderInfo',
					 query:{
						id:id 
					 }
				 })
			 },
			 // 获取用户订单列表
			getOrderList(){
				const toast=this.$toast.loading({
				  message: '',
				  forbidClick: true,
				  loadingType: 'spinner',
				});
						 		
				 this.request.postURL('/api/order/orderList',{
				 	order_status:this.orderStatus,
				 	page:this.page,
				 	pageSize:10,			 	
				 }).then(res=>{
					 				
					this.total=res.data.data.total //给数据条数赋值
					this.last_page=res.data.data.last_page//最后一页
					
					//若数据条目不为0
					this.orderLists.push(...res.data.data.data)//将数据放在列表中
					
					this.loading=false //加载状态结束
					this.finished = false
					//如果list长度大于等于总数据条数
					if(this.orderLists.length>=this.total){
						this.finished=true
						if(this.total == 0){
							this.finishedText='暂无数据'
						}else{							
							this.finishedText='没有更多了'
						}
					}
					
					
					toast.clear()
					
				 }).catch(err=>{
				    
					toast.clear()
				   });
			},
			 // 待支付订单去支付
			 rePay(id){
				 this.$store.dispatch('prePayOrder',id)
			 },
			 
			 onLoad(){	
				 if(this.page<this.last_page){
					this.page++ //分页数+1
					this.getOrderList() 
				 }				 
			 },
			 //去退款订单页面
			 goReturnOrder(id){
				 this.$router.push({
					 path:'/returnOrder',
					 query:{
						id:id 
					 }
				 })
			 }
		},
		mounted() {
				
		},
		created() {
			if(this.$route.query.name){
				this.orderStatus=this.$route.query.name
				this.getOrderList()
			}else{
				this.orderStatus= '全部'
				this.getOrderList()
			}	
		},
	}
</script>

<style  scoped>
	.order-list-title{
		font-size: 12px;
	}
	>>> .van-toast{
		background-color:rgba(0,0,0,0);
	}
	>>> .van-toast .van-toast__loading{
		color: #444444;
	}
	.prepay{
		
	}
</style>
